import React from 'react'
import PropTypes from 'prop-types'
import ReleaseNotesComponent from './ReleaseNotesComponent'
import ReactGA from 'react-ga'
import { Button } from 'react-bootstrap'

import './webarchives.scss'
import LoadingComponent from '../../../core/LoadingComponent/LoadingComponent'
import LinkComponent from '../../../core/LinkComponent/LinkComponent'
import { SIGN_IN_PATH } from '../../../../constants/routes'

class WebArchivesComponent extends React.Component {
    constructor(props) {
        super(props);

        // this.showHideArchives = this.showHideArchives.bind(this);

        this.state = {
            showAllArchives: false,
        }
    }

    componentWillMount() {
        const { isLoading, getArchives } = this.props

        if (!isLoading) {
            getArchives();
        }
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Web Archives Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { title, content, archives, isLoading, user } = this.props

        // showHideArchives = () => {
        //     const { getArchives, api } = this.props;
        //     this.setState({
        //         showArchives: !this.state.showArchives,
        //     });

        //     if (this.state.showArchives) {
        //         getArchives(api, 'latest');
        //     }
        // }

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className="WebArchives-component">
            <h2>{title}</h2>
            <p className="content">{content}</p>
            {!user.uid && <Button>
                <LinkComponent className="redirectToSignIn" url={SIGN_IN_PATH} title="Log In To View" />
            </Button>}
            {user.uid && Object.keys(archives).reverse().map((version, index) => <ReleaseNotesComponent
                key={index}
                version={version}
                releaseNotes={archives[version].sdk}
            />)}
            {user.uid && Object.keys(archives).length > 3 && <span>View More Archives</span>}
        </div>
    }
}

WebArchivesComponent.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    archives: PropTypes.object.isRequired,
    getArchives: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
}

export default WebArchivesComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Archives/WebArchivesComponent.js